var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyself(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fluent:person-12-filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.0026 3.16797C17.3229 3.16797 15.712 3.83523 14.5243 5.02296C13.3365 6.21069 12.6693 7.8216 12.6693 9.5013C12.6693 11.181 13.3365 12.7919 14.5243 13.9796C15.712 15.1674 17.3229 15.8346 19.0026 15.8346C20.6823 15.8346 22.2932 15.1674 23.4809 13.9796C24.6687 12.7919 25.3359 11.181 25.3359 9.5013C25.3359 7.8216 24.6687 6.21069 23.4809 5.02296C22.2932 3.83523 20.6823 3.16797 19.0026 3.16797ZM26.9193 19.0013H11.0859C9.82616 19.0013 8.61798 19.5017 7.72718 20.3925C6.83638 21.2833 6.33594 22.4915 6.33594 23.7513C6.33594 27.2853 7.78944 30.1163 10.1739 32.0321C12.5204 33.9163 15.6681 34.8346 19.0026 34.8346C22.3371 34.8346 25.4848 33.9163 27.8313 32.0321C30.2126 30.1163 31.6693 27.2853 31.6693 23.7513C31.6693 22.4915 31.1688 21.2833 30.278 20.3925C29.3872 19.5017 28.1791 19.0013 26.9193 19.0013Z",
    fill: "#065AD8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyself);
export default __webpack_public_path__ + "static/media/Myself.22be5801cd720fa8204016d7cac2d5d5.svg";
export { ForwardRef as ReactComponent };